/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export class LoadRedlineConfig {
    static readonly type = '[RedlineConfig] Load config';

    constructor(public mapName: string) {}
}

export class SetRedlineLayer {
    static readonly type = '[RedlineService] Set Redline Layer';

    constructor(public layerName: string) {}
}

export class TurnRedlineLayerOn {
    static readonly type = '[RedlineConfig] Turn redline layer on';

    constructor(public layerName: string) {
    }
}

export class TurnRedlineLayerOff {
    static readonly type = '[RedlineConfig] Turn redline layer off';

    constructor(public layerName: string) {
    }
}

export class RedlineVisibilityChanged {
    static readonly type = '[RedlineConfig] Redline visibility changed';
}
